export const SALES_LEGAL_TERMS_NAVIGATION_DATA = [
    {
        id: 'top',
        icon: './image/icon/navigation_icon.svg',
        title: 'Back to top'
    }
]
